import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './downloadBanner.module.css';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

function DownloadBanner(props) {
    const img = maybeImage(props.illustration);

    let bgcolor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';
    let bgcolorbot = (props.bgcolorbot) ? props.bgcolorbot.hex : '#FFFFFF';

    return (
        <div className={styles.sectionDownloadBanner} style={{ backgroundColor: `${bgcolor}`}}>
            <div className={styles.sectionContent}>
                <div class="container mx-auto">
                    <div class={styles.bannerContent}>
                        <div className={styles.contentWrap}>
                            <h2>{props.heading}</h2>
                            <PortableText blocks={props.content} />
                            <div className={styles.downloadBar}>
                                {
                                    (props.appstore) ? 
                                    <a href={props.appstore} target="_blank">
                                        <img src={require('../images/app_store_2.png').default} alt="Download in App Store" />
                                    </a> 
                                    : ``
                                }
                                {
                                    (props.googleplay) ? 
                                    <a href={props.googleplay} target="_blank">
                                        <img src={require('../images/google_play_2.png').default} alt="Download in Google Play" />
                                    </a> 
                                    : ``
                                }
                            </div>
                        </div>
                        <div className={styles.imgWrap}>{img}</div>
                    </div>
                    <div className={styles.mobileDownloadBar}>
                        {
                            (props.appstore) ? 
                            <a href={props.appstore} target="_blank">
                                <img src={require('../images/app_store_2.png').default} alt="Download in App Store" />
                            </a> 
                            : ``
                        }
                        {
                            (props.googleplay) ? 
                            <a href={props.googleplay} target="_blank">
                                <img src={require('../images/google_play_2.png').default} alt="Download in Google Play" />
                            </a> 
                            : ``
                        }
                    </div>
                </div>
            </div>
            <div className={styles.sectionBackground} style={{ backgroundColor: `${bgcolorbot}`}}></div>
        </div>
    );
}
  
export default DownloadBanner;